module.exports = __webpack_public_path__ + "assets/img/bbe6-as.svg";